import { User, type RedirectLoginResult } from '@auth0/auth0-spa-js';
import type {
  AppState,
  GetTokenSilentlyOptions,
  LogoutOptions,
  RedirectLoginOptions,
} from '@auth0/auth0-vue';
import { ref, type App } from 'vue';

const mockAuth0Plugin = {
  install: (app: App): void => {},
  isAuthenticated: ref(true),
  isLoading: ref(false),
  user: ref<User>({
    sub: 'auth0|anyUserId',
    preferred_username: 'anyUserId',
    email: 'anyUserId@homegate.ch',
    'cognito:groups': ['private'],
    email_verified: true,
  }),
  getAccessTokenSilently(options?: GetTokenSilentlyOptions): Promise<string> {
    return Promise.resolve('fake_access_token');
  },
  loginWithRedirect(options?: RedirectLoginOptions<AppState>): Promise<void> {
    return Promise.resolve();
  },
  handleRedirectCallback(url?: string): Promise<RedirectLoginResult<AppState>> {
    return Promise.resolve({} as RedirectLoginResult<AppState>);
  },
  logout(options?: LogoutOptions): Promise<void> {
    return Promise.resolve();
  },
  checkSession(options?: GetTokenSilentlyOptions): Promise<void> {
    return Promise.resolve();
  },
};

export default mockAuth0Plugin;
